// extracted by mini-css-extract-plugin
export default {"OmnibarDrawerContainer":"omnibar-drawer-module__OmnibarDrawerContainer--of9bi"};